window.addEventListener('message', function(event) {
    if (event.data && event.data.action === 'IFRAME_FORM_LOADED') {
        
        const currentParams = new URLSearchParams(window.location.search);
        const previousUrl = document.referrer;
        let previousParams = null;
        
        if (previousUrl) {
            try {
                previousParams = new URL(previousUrl).searchParams;
            } catch (e) {
            }
        }

        const paramNames = ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        const extractedParams = {};

        paramNames.forEach(function(param) {
            if (previousParams && previousParams.has(param)) {
                extractedParams[param] = previousParams.get(param);
            } else if (currentParams.has(param)) {
                extractedParams[param] = currentParams.get(param);
            }
        });

        const payload = {
            action: 'POPULATE_HIDDEN_FIELDS',
            params: extractedParams,
            previousUrl: previousUrl || window.location.href 
        };

        event.source.postMessage(payload, '*');
    }
});